import { ChevronLeft } from 'lucide-react';
import { LoadingIndicator } from '@/components/utils/LoadingIndicator';

export const UnprotectedRouteContainer = ({
  children,
  footer = null,
  isLoading,
  showLogin,
}: {
  children: React.ReactNode;
  footer?: React.ReactNode;
  isLoading?: boolean;
  showLogin: (disable: boolean) => void;
}) => {
  const handleGoBack: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    showLogin(false);
  };

  return (
    <div className="flex justify-center min-h-screen py-8">
      <div className="flex flex-col justify-between md:w-9/12 md:max-w-screen-md flex-1">
        <div className="px-5">
          <div>
            <a
              onClick={handleGoBack}
              href="#"
              className="text-sm mb-4 flex items-center ml-[-5px]"
            >
              <ChevronLeft size={24} />
              <span className="hidden md:block ml-1">Back</span>
            </a>
          </div>
          <div className="mt-8 md:mt-20 flex justify-center">
            <div className="flex-1 md:max-w-xs">
              {isLoading ? (
                <div className="w-96 flex justify-center">
                  <LoadingIndicator />
                </div>
              ) : (
                children
              )}
            </div>
          </div>
        </div>

        <div>{footer}</div>
      </div>
    </div>
  );
};
